module.exports = __webpack_public_path__ + "static/media/detail_edit.484c190b.svg";